<h1>Privacy statement (website registratie platform)</h1>

<p>Wilt u zich inschrijven voor een evenement of missie? Dan hebben wij uw persoonsgegevens, zoals uw naam, e-mailadres
  of woon- werkadres nodig. Bij het aanvraagformulier staat vermeld welke gegevens bzconfregistration.azurewebsites.net
  gebruikt en waarvoor. We vragen u ook om toestemming te geven voor het gebruik van uw persoonsgegevens voor het doel
  van de app.</p>

<p>Hoe gaan we op bzconfregistration.azurewebsites.net en de bz conferencing app om met uw persoonsgegevens?</p>

<h2>Doel verwerking persoonsgegevens</h2>
<p>bzconfregistration.azurewebsites.net bewaart persoonsgegevens niet langer dan nodig is voor het doel waarvoor u ze
  heeft achtergelaten. bzconfregistration.azurewebsites.net gebruikt uw persoonsgegevens slechts met uw toestemming om
  het gebruik van de app te faciliteren, u gebruik te kunnen laten maken van de app en om u te kunnen informeren
  voorafgaand en tijdens een evenement of missie. Een uitnodiging om u te registreren ontvangt u via de organisatie van
  het evenement of de missie. De organisator van het evenement of de missie kan via de app aanvullende vragen stellen.
</p>
<p>De BZ conferencing app gebruikt deze informatie en uw naam om u in contact te brengen met andere deelnemers en
  gebruikers van de BZ conferencing app. De bz conferencing app meet uw bezoek. Zo kan het ministerie van Buitenlandse
  Zaken het gebruik van de app analyseren. En het gemak voor gebruikers vergroten. De meting is anoniem. Wij registreren
  hiervoor geen persoonsgegevens.</p>

<p>Gegevens die wij opslaan zijn onder andere:</p>
<ul>
  <li>het type telefoon</li>
  <li>de versie van het besturingssysteem</li>
  <li>het netwerkadres (om het land van de bezoeker te achterhalen)</li>
  <li>gegevens om het aantal unieke gebruikers te bepalen</li>
</ul>

<p>Deze gegevens zullen wij niet:</p>
<ul>
  <li>combineren met andere bronnen</li>
  <li>doorgeven aan anderen</li>
  <li>gebruiken om te bepalen wie u bent</li>
</ul>

<h2>Uitwisseling van gegevens</h2>
<p>De uitvoering van de wettelijke taak kan met zich meebrengen dat het ministerie van Buitenlandse Zaken gegevens,
  inclusief uw persoonsgegevens, deelt met andere organisaties. Dit gebeurt op basis van een van de grondslagen uit de
  AVG. Bijvoorbeeld als iemand via de site strafbare feiten pleegt of strafbare uitingen doet.</p>

<h2>Beveiliging persoonsgegevens</h2>
<p>Het ministerie van Buitenlandse Zaken zorgt voor passende beveiliging van uw persoonsgegevens die zij onder zich
  heeft.</p>

<h2>Bewaartermijn:</h2>
<p>Uw persoonsgegevens worden niet langer bewaard dan strikt noodzakelijk is om de doelen te realiseren waarvoor uw
  gegevens worden verzameld, tenzij wij wettelijk verplicht worden deze langer te bewaren. Het ministerie van
  Buitenlandse Zaken verwijdert de gegevens na een jaar + 1 maand. Alleen algemene statistieken slaan we op voor
  onbepaalde tijd.</p>

<h2>Uw privacyrechten</h2>
<p>In de volgende situaties kunt u een verzoek indienen:</p>
<ul>
  <li>U wilt weten welke persoonsgegevens we van u verwerken</li>
  <li>U wilt uw persoonsgegevens laten aanpassen</li>
  <li>U wilt persoonsgegevens laten verwijderen</li>
  <li>U wilt dat we uw persoonsgegevens beperkt verwerken</li>
  <li>U wilt bezwaar maken</li>
</ul>

<p>Uw verzoek kunt u via het emailadres djz-nr@minbuza.nl of via de post indienen, het postadres is:</p>
<p>
  Ministerie van Buitenlandse Zaken<br/>
  DJZ<br/>
  Postbus 20061<br/>
  2500 EB Den Haag<br/>
</p>

<h2>Contactgegevens Functionaris voor de Gegevensbescherming</h2>
<p>Het ministerie van Buitenlandse Zaken heeft een Functionaris voor de Gegevensbescherming (FG). Deze functionaris houdt intern toezicht op de naleving van privacywetgeving. U kunt contact met deze functionaris opnemen via het postadres:</p>

<p>
Functionaris voor de Gegevensbescherming<br/>
Ministerie van Buitenlandse Zaken<br/>
VCI<br/>
Postbus 20061<br/>
2500 EB Den Haag<br/>
</p>

<p>Lees hier de algemene BZ privacyverklaring:</p>
<a href="https://www.rijksoverheid.nl/ministeries/ministerie-van-buitenlandse-zaken/privacy" target="_blank">https://www.rijksoverheid.nl/ministeries/ministerie-van-buitenlandse-zaken/privacy</a>